import { useState } from "react";
import WebLottiePlayer from "../../../WebStoryScreen/Components/WebLottiePlayer";
import "./HobbySelector.scss";

interface HobbyItem {
  id?: number;
  name: string;
  status?: boolean;
  images?: { id?: number; name?: string; url: string }[];
}

interface HobbySelectorProps {
  items: HobbyItem[];
  onSubmit: (selected: { name: string; status: boolean }[]) => void;
}

function HobbySelector({ items, onSubmit }: HobbySelectorProps) {
  const [selected, setSelected] = useState<Set<string>>(new Set());

  const toggle = (name: string) => {
    setSelected((prev) => {
      const next = new Set(prev);
      if (next.has(name)) {
        next.delete(name);
      } else {
        next.add(name);
      }
      return next;
    });
  };

  const handleContinue = () => {
    const result = items.map((item) => ({
      name: item.name,
      status: selected.has(item.name),
    }));
    onSubmit(result);
  };

  const hasSelection = selected.size > 0;
  const safeItems = Array.isArray(items) ? items : [];

  return (
    <div className="hobby-selector">
      <div className="hobby-selector__grid">
        {safeItems.map((item) => {
          const isSelected = selected.has(item.name);
          const iconUrl = item.images?.[0]?.url;
          return (
            <button
              key={item.name}
              type="button"
              className={`hobby-selector__item${isSelected ? " hobby-selector__item--selected" : ""}`}
              onClick={() => toggle(item.name)}
            >
              {iconUrl && (
                <WebLottiePlayer
                  source={iconUrl}
                  className="hobby-selector__icon"
                  loop
                  autoPlay
                />
              )}
              <span className="hobby-selector__label">{item.name}</span>
            </button>
          );
        })}
      </div>

      <button
        type="button"
        className={`hobby-selector__continue${hasSelection ? " hobby-selector__continue--active" : ""}`}
        disabled={!hasSelection}
        onClick={handleContinue}
      >
        Continue
      </button>
    </div>
  );
}

export default HobbySelector;
